export default __webpack_public_path__ + "static/media/subscription_basic.6450e3a9.png";